import Document from './Document'

export default class DocumentList {
  public readonly page: number // calculated page number
  public readonly totalPages: number // total pages

  constructor(
    public readonly from: number, // skipped documents
    public readonly pageSize: number, // document's limit
    public readonly total: number, // total documents
    public readonly items: Document[] // documents
  ) {
    this.page = Math.floor(from / pageSize) + 1
    this.totalPages = Math.ceil(this.total / pageSize)
  }
}
